import { render, staticRenderFns } from "./examChapter.vue?vue&type=template&id=6d49a941&scoped=true&"
import script from "./examChapter.vue?vue&type=script&lang=js&"
export * from "./examChapter.vue?vue&type=script&lang=js&"
import style0 from "./examChapter.vue?vue&type=style&index=0&id=6d49a941&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d49a941",
  null
  
)

export default component.exports